












import { defineComponent } from "@vue/composition-api";
import { RunForm } from "@/components.run/run-form";
import { getProps } from "../../ts/NodeComponent";

type FormParams = {};

export default defineComponent({
	
	emits:[ "end", "previous" ],
	components:{
		RunForm
	},
	props:getProps<FormParams>(),
	setup(_, context){

		const onEnd = () => context.emit("end");
		const onBack = () => context.emit("previous");

		return {
			onEnd,
			onBack
		};

	}
});
